import React from "react";
import { Link } from "react-router-dom";
import Services from "../components/sections/Services";
import Jobs from "../components/sections/Jobs";
import Process from "../components/sections/Process";
import Testimonials from "../components/sections/Testimonials";
import FAQ from "../components/sections/FAQ";
import RecruitmentCategories from "../components/sections/RecruitmentCategories";

export default function HomePage() {
  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white mb-3 animated slideInDown">
                Connecting Talent to Global Opportunities
              </h1>
              <p className="fs-4 text-white mb-4 animated slideInDown">
                We specialize in providing skilled manpower to companies
                worldwide, with a strong focus on Gulf countries. Our mission is
                to bridge the gap between opportunity and talent by delivering
                reliable, efficient, and compliant recruitment solutions.
              </p>

              {/* --- CTA Buttons Start --- */}
              <div className="d-flex justify-content-center flex-wrap animated slideInUp">
                <Link
                  to="/contact"
                  className="btn btn-light text-white bg-primary py-md-3 px-md-5 me-3 mt-2 fw-bold shadow-sm"
                  style={{ borderRadius: "30px" }}
                >
                  Apply for a Job
                </Link>
                <Link
                  to="/services"
                  className="btn btn-outline-light py-md-3 px-md-5 mt-2 fw-bold"
                  style={{ borderRadius: "30px" }}
                >
                  Hire Manpower
                </Link>
              </div>
              {/* --- CTA Buttons End --- */}
            </div>
          </div>
        </div>
      </div>

      {/* About Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: 400 }}
            >
              <div className="position-relative h-100">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                  src="assets/img/about-img.jpg"
                  alt="About All World Recruiting"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h6 className="section-title bg-white text-start text-primary pe-3">
                About Us
              </h6>
              <h1 className="mb-4">
                Welcome to{" "}
                <span className="text-primary">
                  All World Recruiting & Overseas Employment Agency
                </span>
              </h1>
              <p className="mb-4">
                All World Recruiting & Overseas Employment Agency is dedicated
                to supplying qualified and dependable manpower across
                international markets, especially in Gulf countries. With a deep
                understanding of global hiring standards and workforce
                requirements, we help individuals build successful careers
                abroad while assisting companies in finding the right talent.
              </p>
              <div className="row gy-2 gx-4 mb-4">
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Overseas Opportunities
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Skilled Manpower Supply
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Gulf Region Experts
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    24/7 Support
                  </p>
                </div>
              </div>
              <Link className="btn btn-primary py-3 px-5 mt-2" to="/About">
                Read More
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Services />
      <Jobs />
      {/* <RecruitmentCategories /> */}
      <Process />
      <Testimonials />
      <FAQ />
    </div>
  );
}
